export default "__VITE_ASSET__DlFrEA_1__"